import React from "react";
import { default as Loader } from '../loader';

import themes from "../../styles/themes";

type validFonts = 'gilroy' | 'inter';
type validThemes = 'primary' | 'secondary';
type validTypes = "button" | "submit" | "reset";
export interface ButtonProps {
  label?: string,
  type?: validTypes,
  theme?: validThemes,
  font?: validFonts,
  maxWidth?: string,
  isLoading?: boolean,
  disabled?: boolean,
  border?: boolean,
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

const getLoaderTheme = (theme?: validThemes) => {
  if (theme == 'primary') {
    return 'white';
  }
  return 'primary';
}

export const Button = (
  {
    label = '',
    type = 'button',
    theme = 'primary',
    font = 'gilroy',
    isLoading = false,
    disabled = false,
    border = false,
    onClick,
  } : ButtonProps
) => {
  const handleOnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (isLoading || disabled) {
      e.preventDefault()
    } else if (onClick) {
      onClick(e);
    }
  }
  const themeKey = theme as keyof typeof themes.button;
  const themeClasses = themes.button[themeKey]?.classes;

  const sizeClasses = 'w-full rounded-sm p-sm';
  let fontClasses = 'font-bold';
  let borderClasses = '';

  switch (font) {
    case "inter":
      fontClasses += ' font-inter';
      break;
    case "gilroy":
    default:
      fontClasses += ' font-gilroy';
      break;
  }

  if (border) {
    borderClasses = `border-2 disabled:border-on-disabled border-accents-primary`;
  }
  
  return (
      <button 
        type={type}
        disabled={!isLoading && disabled}
        onClick={handleOnClick} 
        className={`${sizeClasses} ${themeClasses} ${fontClasses} ${borderClasses}`}>
          {isLoading ? <div className="h-6"><Loader theme={getLoaderTheme(theme)} /></div> : label}
      </button>
  );
};

export default Button;